import { defineComponent as _defineComponent } from 'vue'
import SparePartsCategoryListPrivate from './SparePartsCategoryListPrivate.vue';
import SparePartsCategoryListProfessional from './SparePartsCategoryListProfessional.vue';
import { store } from '@/store';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FindSparePartPage',
  props: {
    headline: null,
    model: null
  },
  setup(__props: any) {



const isPrivateMode = computed(() => store.getters['app/isPrivateMode']);

const ear = ref<number>(0);

function updateEar(amount: number) {
    ear.value = amount;
}

return { __sfc: true,isPrivateMode, ear, updateEar, SparePartsCategoryListPrivate, SparePartsCategoryListProfessional }
}

})